"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftConflictDto = instanceOfShiftConflictDto;
exports.ShiftConflictDtoFromJSON = ShiftConflictDtoFromJSON;
exports.ShiftConflictDtoFromJSONTyped = ShiftConflictDtoFromJSONTyped;
exports.ShiftConflictDtoToJSON = ShiftConflictDtoToJSON;
exports.ShiftConflictDtoToJSONTyped = ShiftConflictDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftConflictDto interface.
 */
function instanceOfShiftConflictDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function ShiftConflictDtoFromJSON(json) {
    return ShiftConflictDtoFromJSONTyped(json, false);
}
function ShiftConflictDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'facilityId': json['facilityId'] == null ? undefined : json['facilityId'],
    };
}
function ShiftConflictDtoToJSON(json) {
    return ShiftConflictDtoToJSONTyped(json, false);
}
function ShiftConflictDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'facilityId': value['facilityId'],
    };
}
//# sourceMappingURL=ShiftConflictDto.js.map